import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Section from "../../components/Section";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import SuccessProcess from '../../components/Notifications/SuccessProcess';
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSave,
    faRotate,
    faCircleArrowLeft,
    faXmark,
    faEyeSlash,
    faEye
} from "@fortawesome/free-solid-svg-icons";
import apiClient from "../../axios";

const UsersForm = ({ handleLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [description, setDescription] = useState("");
    const [confirmarClave, setConfirmarClave] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showPassword2, setShowPassword2] = useState(false);
    const [email, setEmail] = useState("");
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [errorsMessage, setErrorMessage] = useState({});
    const [isLoginVisible, setIsLoginVisible] = useState(false);
    const [errors, setErrors] = useState({});
    const [customerTypeId, setCustomerTypeId] = useState(0);
    const [grupos, setGrupos] = useState([]);
    const [notificationBlock, setNotificationBlock] = useState(false);
    const [messageBlock, setMessageBlock] = useState(false);
    const [isStaff, setStaff] = useState(0);

    useEffect(() => {
        if (id) {
            const fetchProduct = async () => {
                try {
                    const response = await apiClient.get(`/users/${id}`);
                    setUserName(response.data.userName);
                    setEmail(response.data.email);
                    setDescription(response.data.description);
                    setPassword(response.data.password);
                    setConfirmarClave(response.data.password);
                    setCustomerTypeId(response.data.customerTypeId);
                    setStaff(response.data.isStaff);
                } catch (error) {
                    console.error("Error al cargar el Usuario", error);
                }
            };
            fetchProduct();
        }
    }, [id]);

    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const toggleShowPassword2 = () => {
        setShowPassword2((prevShowPassword) => !prevShowPassword);
    };
    const handleCloseBlock = () => {
        setNotificationBlock(false);
    };
    useEffect(() => {
        const fetchGroups = async () => {
            try {
                const response = await apiClient.get("/customer_types");
                setGrupos(response.data);
            } catch (error) {
                console.error("Error fetching groups:", error);
            }
        };
        fetchGroups();
    }, []);

    const validateEmail = (email) => {
        // Expresión regular para validar el formato de email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email); // Solo valida el formato del correo
    };
    const handleChange = (e) => {
        const value = e.target.value;
        setEmail(value);

        // Validar el email
        if (!validateEmail(value)) {
            setErrors({
                email: 'Email inválido. Debe contener "@" y un dominio válido.',
            });
        } else {
            setErrors({});
        }
    };

    const validateFields = () => {
        let validationErrors = {};
        if (!userName) {
            validationErrors.userName = "El Campo es Obligatorio";
        }
        if (!email) validationErrors.email = "El Campo es Obligatorio";
        if (!password) validationErrors.password = "El Campo es Obligatorio";
        if (!customerTypeId) validationErrors.customerTypeId = "El Campo es Obligatorio";
        if (password !== confirmarClave) {
            validationErrors.confirmarClave = "Las claves no coinciden";
        }
        return validationErrors;
    };

    const toggleSwitch = () => {
        setStaff((prev) => prev === 0 ? 1 : 0);
    };
    const handleSave = async () => {
        const validationErrors = validateFields();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            let response;
            if (id) {
                const payloadUpdate = {
                    password,
                    description,
                    email,
                    customerTypeId,
                    isStaff
                };
                response = await apiClient.patch(
                    `/users/${id}`,
                    payloadUpdate
                );
                if (response.status === 200) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setIsLoginVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/UsersList");
                }
            } else {
                const payload = {
                    userName,
                    password,
                    email,
                    description,
                    customerTypeId,
                    isStaff
                };
                response = await apiClient.post("/users", payload);
                if (response.status === 201) {
                    setIsSuccessVisible(true);
                    setIsErrorVisible(false);
                    setErrors({});
                    setTimeout(() => {
                        setIsSuccessVisible(false);
                    }, 4000);
                    navigate("/UsersList");
                }
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setIsLoginVisible(true);
            } else if (error.response?.data?.message.startsWith("USER_ALREADY_EXIST")) {
                setMessageBlock(`El Nombre de Usario ingresado ya existe.`)
                setNotificationBlock(true);

            } else if (error.response?.data?.message.startsWith("EMAIL_ALREADY_IN_USE")) {
                setMessageBlock(`El Email ingresado ya esta relacionado a otro Usuario.`)
                setNotificationBlock(true);
            }
            else {
                setErrorMessage("Oops!. Ocurrio un error al crear el Usario");
                setIsLoginVisible(false);
                setIsErrorVisible(true);
                setIsSuccessVisible(false);
                setTimeout(() => {
                    setIsErrorVisible(false);
                }, 4000);
            }
        }
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Usuarios" />
            <Section>
                <div className="button-return-container">
                    <FontAwesomeIcon
                        className="basic-shortcut-icon"
                        style={{ cursor: "pointer" }}
                        icon={faCircleArrowLeft}
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/UsersList");
                        }}
                    />
                </div>
            </Section>
            <div className="moduleNew-form-container">
                <h3 className="basic-info-form-title">Información del Usario</h3>
                <div className="basic-info-form-grid">
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.userName ? "red" : "revert-layer" }}>
                            Nombre
                        </label>
                        <input
                            type="text"
                            placeholder="Nombre"
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            readOnly={!!id}
                        />
                        {errors.userName && <p className="error-message">{errors.userName}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label>
                            Descripción
                        </label>
                        <input
                            type="text"
                            placeholder="Descripción"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.email ? "red" : "revert-layer" }}>
                            {" "}
                            Email
                        </label>
                        <input
                            type="text"
                            placeholder="Email"
                            value={email}
                            onChange={handleChange}

                        />
                        {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.password ? "red" : "revert-layer" }}>
                            Clave
                        </label>
                        <div className="password-input-container">
                            <input
                                className="text-box-login2"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Contraseña"
                            />
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye}
                                className="password-toggle-icon2"
                                onClick={toggleShowPassword}
                            />
                        </div>
                        {errors.password && <p className="error-message">{errors.password}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.confirmarClave ? "red" : "revert-layer" }}>
                            Confirmar Clave
                        </label>
                        <div className="password-input-container">
                            <input
                                className="text-box-login2"
                                type={showPassword2 ? "text" : "password"}
                                placeholder="Confirmar Clave"
                                value={confirmarClave}
                                onChange={(e) => setConfirmarClave(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={showPassword2 ? faEyeSlash : faEye}
                                className="password-toggle-icon2"
                                onClick={toggleShowPassword2}
                            />
                        </div>
                        {errors.confirmarClave && <p className="error-message">{errors.confirmarClave}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <label style={{ color: errors.customerTypeId ? "red" : "revert-layer" }}>
                            GRUPO
                        </label>
                        <select
                            value={customerTypeId}
                            onChange={(e) => setCustomerTypeId(e.target.value)}
                        >
                            <option value="">Seleccione un Grupo de Cliente</option>
                            {grupos.map((grupo) => (
                                <option key={grupo.id} value={grupo.id}>
                                    {grupo.description}
                                </option>
                            ))}
                        </select>
                        {errors.customerTypeId && <p className="error-message">{errors.customerTypeId}</p>}
                    </div>
                    <div className="basic-info-form-group">
                        <div className="basic-info-form-switch">
                            <label>Técnico</label>
                            <div className="slider-container-contract" onClick={toggleSwitch}>
                                <div
                                    className={`slider-option-contract ${isStaff === 1
                                        ? "active-contract"
                                        : "inactive-contract"
                                        }`}
                                >
                                    Sí
                                </div>
                                <div
                                    className={`slider-option-contract ${isStaff === 0
                                        ? "active-contract"
                                        : "inactive-contract"
                                        }`}
                                >
                                    No
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="basic-form-footer">
                    <button
                        className="basic-custom-button"
                        onClick={(e) => {
                            e.stopPropagation();
                            navigate("/UsersList");
                        }}
                    >
                        <FontAwesomeIcon icon={faXmark} className="basic-shortcut-icon" />
                        Cancelar
                    </button>
                    <button
                        className="basic-custom-button"
                        onClick={handleSave}
                    >
                        <FontAwesomeIcon
                            icon={id ? faRotate : faSave}
                            className="basic-shortcut-icon"
                        />
                        {id ? "Actualizar" : "Guardar"}
                    </button>
                </div>
            </div>
            <SuccessNotification
                message={
                    id
                        ? "El Usuario se ha Actualizado Correctamente."
                        : "El Usuario se ha Creado Correctamente."
                }
                isVisible={isSuccessVisible}
                onClose={() => setIsSuccessVisible(false)}
            />
            <ErrorNotification
                message={errorsMessage}
                isVisible={isErrorVisible}
                onClose={() => setIsErrorVisible(false)}
            />
            <LoginNotification
                message="Vuele a iniciar sesión"
                isVisible={isLoginVisible}
                onClose={() => setIsLoginVisible(false)}
                onLogout={handleLogout}
            />
            {notificationBlock && (
                <SuccessProcess
                    enca={true}
                    message={`No se puede Crear el Usario debido a : ${messageBlock}`}
                    isVisible={notificationBlock}
                    onClose={handleCloseBlock}
                    redirectOnOk={true}
                    pageNavigate={"/UsersList"}
                    whatsApp={false}
                />
            )}

        </div>
    );
};

export default UsersForm;
